module.exports = __webpack_public_path__ + "static/overview-shop-2@2x-11e11ce44b553a7b2b51e5c1e0ceb0e1.jpg";